"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SyncIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SyncIcon, _React$PureComponent);

  function SyncIcon() {
    _classCallCheck(this, SyncIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(SyncIcon).apply(this, arguments));
  }

  _createClass(SyncIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'sync-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M10.996564,5.49958009 C11.6475006,5.49958009 12.1304537,6.11654299 11.9684694,6.74750505 C11.4135234,8.90437534 9.45571385,10.4992794 7.12494057,10.4992794 L7.12494057,10.4992794 L6.99995273,10.4992794 L6.99995273,11.4992193 C6.99995273,11.9111945 6.48700263,12.1461804 6.12703764,11.8991952 L6.12703764,11.8991952 L3.21832059,9.89931551 C2.92834879,9.69932753 2.92834879,9.29935159 3.21832059,9.09936361 L3.21832059,9.09936361 L6.12703764,7.09948388 C6.48700263,6.85249873 6.99995273,7.0874846 6.99995273,7.49945983 L6.99995273,7.49945983 L6.99995273,8.49939969 L7.12494057,8.49939969 C8.50580625,8.49939969 9.66869313,7.5664558 10.0176592,6.29653217 C10.142647,5.84055959 10.5206103,5.49958009 10.9945642,5.49958009 L10.9945642,5.49958009 Z M5.00004727,0.500780706 C5.00004727,0.088805481 5.51299737,-0.146180388 5.87296236,0.100804759 L5.87296236,0.100804759 L8.78167941,2.10068449 C9.07165121,2.30067247 9.07165121,2.70164835 8.78167941,2.90063639 L8.78167941,2.90063639 L5.87296236,4.90051612 C5.51299737,5.14750127 5.00004727,4.91351534 5.00004727,4.50054017 L5.00004727,4.50054017 L5.00004727,3.50060031 L4.87505943,3.50060031 C3.49419375,3.50060031 2.33130687,4.4335442 1.98134091,5.70346783 C1.85635307,6.16044035 1.47938974,6.50041991 1.00543584,6.50041991 L1.00543584,6.50041991 C0.352499357,6.50041991 -0.130453664,5.88345701 0.0315305789,5.25249495 C0.586476597,3.09562466 2.54428615,1.50072057 4.87505943,1.50072057 L4.87505943,1.50072057 L5.00004727,1.50072057 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return SyncIcon;
}(_react.default.PureComponent);

exports.default = SyncIcon;
SyncIcon.defaultProps = {
  color: 'inherit'
};
SyncIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};